import RecordsList   from '../../../pages/music/record/List';
import RecordsCreate from '../../../pages/music/record/Create';
import RecordsEdit   from '../../../pages/music/record/Edit';
import {
	getMusicRecordCreateRoute,
	getMusicRecordEditRoute,
	getMusicRecordLyricsRoute,
	getMusicRecordsRoute
}                    from './factory/records';
import Lyrics        from '../../../pages/music/record/Lyrics';

/**
 * React Router v7 doesn't use 'exact' prop anymore.
 * Routes by default match 'exactly' unless there is a * or a splat parameter in the path.
 * For more details, see the React Router v7 documentation.
 */
const routes = [
	{
		path: getMusicRecordsRoute(),
		component: RecordsList,
		type: 'route',
		loginRequired: true,
	},
	{
		path: getMusicRecordCreateRoute(),
		component: RecordsCreate,
		type: 'route',
		loginRequired: true,
	},
	{
		path: getMusicRecordLyricsRoute(),
		component: Lyrics,
		exact: false,
		type: 'route',
		loginRequired: true,
	},
	{
		path: getMusicRecordEditRoute(),
		component: RecordsEdit,
		exact: false,
		type: 'route',
		loginRequired: true,
	},
];

export default routes;
